import React from 'react';
import wordmark from '../assets/stage8-wordmark.png';
import { cn } from '../lib/utils';

/* The STAGE8 wordmark. Size it by height through className (e.g. h-[24px]); the width follows
   from the image, and the width/height attributes reserve that box before the file loads. */
export default function Wordmark({ className, style }) {
  return (
    <img
      src={wordmark}
      alt="STAGE8"
      width={438}
      height={144}
      draggable={false}
      className={cn('block w-auto select-none', className)}
      style={style}
    />
  );
}
